import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/contul-meu");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bubble-bg flex min-h-[80vh] items-center justify-center px-6 py-16" data-testid="register-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_40px_rgba(2,132,199,0.08)]">
        <h1 className="font-display text-3xl font-black tracking-tight text-slate-900">Creează cont</h1>
        <p className="mt-2 text-slate-500">Comandă mai rapid și urmărește-ți comenzile.</p>

        {error && <div className="mt-5 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600" data-testid="register-error">{error}</div>}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="name">Nume complet</Label>
            <Input id="name" value={form.name} onChange={update("name")} className="mt-1.5" data-testid="register-name" required />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={form.email} onChange={update("email")} className="mt-1.5" data-testid="register-email" required />
          </div>
          <div>
            <Label htmlFor="phone">Telefon</Label>
            <Input id="phone" value={form.phone} onChange={update("phone")} className="mt-1.5" data-testid="register-phone" />
          </div>
          <div>
            <Label htmlFor="password">Parolă (min. 6 caractere)</Label>
            <Input id="password" type="password" value={form.password} onChange={update("password")} className="mt-1.5" data-testid="register-password" required minLength={6} />
          </div>
          <Button type="submit" size="lg" disabled={loading} className="w-full rounded-full bg-sky-600 hover:bg-sky-500" data-testid="register-submit">
            {loading ? "Se creează..." : "Creează cont"}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-slate-500">
          Ai deja cont? <Link to="/autentificare" className="font-semibold text-sky-600 hover:underline">Autentifică-te</Link>
        </p>
      </div>
    </div>
  );
}
